export default "__VITE_ASSET__BMc2Legy__"